import { globalObject } from "helpers/globalObject";

export function getAppConfig() {
  return globalObject.config;
}

export function setAppConfig(config) {
  globalObject.config = config;
}
